module.exports = __webpack_public_path__ + "static/media/home6.80fa3338.png";